export const MIN_WIDTH_LG = '(min-width: 1024px)';
export const MIN_WIDTH_SM = '(min-width: 640px)';
